// Module
var code = "<svg id=15f42c32-b52e-4426-81c2-abff64de2959 data-name=\"Layer 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><title>Aborted</title><path d=M12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3ZM4,12a8,8,0,0,1,8-8,7.92,7.92,0,0,1,5.28,2L6,17.28A7.92,7.92,0,0,1,4,12Zm8,8a7.92,7.92,0,0,1-5.28-2L18,6.72A7.92,7.92,0,0,1,20,12,8,8,0,0,1,12,20Z /></svg>";
// Exports
module.exports = code;